import { useScrollToTop } from '@/hooks/useScrollToTop'
import { useVersionCheck } from '@/hooks/useVersionCheck'
import { Snackbar } from '@/components/ui/Snackbar'
import { UpdateBanner } from '@/components/ui/UpdateBanner'
import { Outlet } from 'react-router-dom'

export const RootLayout = () => {
  useScrollToTop()
  const { updateAvailable } = useVersionCheck()

  return (
    <div>
      <UpdateBanner visible={updateAvailable} />
      <Outlet />
      <Snackbar />
    </div>
  )
}
